module.exports = __webpack_public_path__ + "static/media/Smiley_rechterarm_blij.d646dac8.png";